import { render, staticRenderFns } from "./CertificateDesign.vue?vue&type=template&id=d66b3d4a&scoped=true&"
import script from "./CertificateDesign.vue?vue&type=script&lang=js&"
export * from "./CertificateDesign.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDesign.vue?vue&type=style&index=0&id=d66b3d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66b3d4a",
  null
  
)

export default component.exports